import { isProd } from "./axios";

const stagingURl = "https://staged.flamingos.dev/";
const baseURL = "https://api.flamingos.dev";
// const baseURL = "http://127.0.0.1:8000"

export const getSyncStatusURl = () =>
  (isProd ? baseURL : stagingURl) + `/datasources/status`;
